import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { format as formatDate, formatRelative, formatDistance, isDate } from 'date-fns'
import { enGB, fr } from 'date-fns/locale'
import resources from './translation.json'

const locales = { enGB, fr }
const DATE_FORMATS = {
  short: 'P',
  long: 'PPPP'
}

i18n.use(initReactI18next).init({
  resources,
  lng: navigator.language || 'fr',
  fallbackLng: 'enGB',

  interpolation: {
    escapeValue: false,
    format: (value, format, lng) => {
      if (isDate(value)) {
        const locale = locales[lng] || locales.enGB
        const now = new Date()

        if (format === 'short') return formatDate(value, DATE_FORMATS.short, { locale })
        if (format === 'long') return formatDate(value, DATE_FORMATS.long, { locale })
        if (format === 'relative') return formatRelative(value, now, { locale })
        if (format === 'ago') return formatDistance(value, now, { locale, addSuffix: true })

        return formatDate(value, format, { locale })
      }
      return value
    }
  }
})

export default i18n
